module.exports = __webpack_public_path__ + "img/03_no.ca6c2ab9.svg";